// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { AddressFields } from '@/components/ui/AddressFields'
import type { OnboardingData } from '@/types'

interface Step5LocationProps {
  data:     Partial<OnboardingData>
  onChange: (updates: Partial<OnboardingData>) => void
  errors:   Partial<Record<keyof OnboardingData, string>>
}

export function Step5Location({ data, onChange }: Step5LocationProps) {
  return (
    <div className="flex flex-col gap-5">
      <div>
        <h2 className="text-lg font-semibold text-ink mb-1">Adres</h2>
        <p className="text-sm text-ink-3">
          Optioneel. Vul postcode en huisnummer in - straatnaam en woonplaats worden automatisch ingevuld.
          Deze gegevens worden overgenomen naar Persoonlijke gegevens.
        </p>
      </div>

      <AddressFields
        values={{
          postalCode:          data.postalCode          ?? '',
          houseNumber:         data.houseNumber         ?? '',
          houseNumberAddition: data.houseNumberAddition ?? '',
          street:              data.street              ?? '',
          city:                data.city                ?? '',
        }}
        onChange={(field, value) => {
          if (field === 'postalCode')          onChange({ postalCode:          value.toUpperCase() })
          else if (field === 'houseNumber')    onChange({ houseNumber:         value })
          else if (field === 'houseNumberAddition') onChange({ houseNumberAddition: value })
          else if (field === 'street')         onChange({ street:              value })
          else if (field === 'city')           onChange({ city:                value })
        }}
        showAddition
      />

      <p className="text-xs text-ink-4 bg-sand px-3.5 py-3 rounded-xl leading-relaxed">
        Uw adresgegevens worden alleen lokaal opgeslagen op dit apparaat en niet gedeeld met derden.
      </p>
    </div>
  )
}
